/**
 * @fileoverview Provides the `YoutubeVideo` React component, which embeds a YouTube video using the `lite-youtube` custom element. It accepts a `videoId`, `title`, and optional `footer` via the `YoutubeVideoProps` interface.
 */

import React from 'react'
import '../styles/components/YoutubeVideo.css'

interface YoutubeVideoProps {
  videoId: string
  title: string
  footer?: React.ReactNode
}

const YoutubeVideo: React.FC<YoutubeVideoProps> = ({ videoId, title, footer }) => {
  return (
    <div className="video-container">
      <div
        dangerouslySetInnerHTML={{
          __html: `<lite-youtube videoid="${videoId}" playlabel="Play: ${title}" title="${title}"></lite-youtube>`,
        }}
      />
      {footer && <div className="video-footer">{footer}</div>}
    </div>
  )
}

export default YoutubeVideo
